module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_6.1238fd17.png";